import React, { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import Tooltip from "@mui/material/Tooltip";
import PopupForm from "../utils/PopupForm";
import { transaction_create } from "../../actions/transaction";
import { useDispatch, useSelector } from "react-redux";

function MyTask(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

MyTask.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function createData(name, startDate, endDate, status, badgeClass, budget) {
  return {
    name,
    startDate,
    endDate,
    status,
    badgeClass,
    budget,
  };
}

const rows = [
  createData(
    "Public Beta Release",
    "1 Jan 2022",
    "1 Apr 2022",
    "Completed",
    "successBadge",
    "$1250"
  ),
  createData(
    "Fix Platform Errors",
    "1 Mar 2022",
    "1 May 2022",
    "Completed",
    "successBadge",
    "$1550"
  ),
  createData(
    "Launch our Mobile App",
    "15 Apr 2022",
    "15 Jun 2022",
    "On Going",
    "primaryBadge",
    "$2500"
  ),
].sort((a, b) => (a.name < b.name ? -1 : 1));

const MyTasks = ({
  data,
  cus_name,
  cus_id,
  total_sales,
  recevied_amount,
  pendding_amount,
}) => {
  console.log(cus_id, cus_name, "NamePro");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const user = useSelector((state) => state.layout.profile);
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [openPopUp, setOpenPopUp] = useState(false);
  const [formStructure, setFormStructure] = useState([
    {
      id: "1",
      type: "inputBox",
      title: "Customer Name",
      name: "customer",
      required: true,
      disabled: true,
      size: "12",
    },
    {
      id: "2",
      type: "inputBox",
      title: "Amount",
      name: "amount",
      required: true,
      // disabled:true,
      size: "12",
    },
    {
      id: "3",
      type: "select",
      title: "Payment Mode",
      name: "mode_of_payment",
      options: ["Cash", "Cheque", "Credit Card", "NEFT/RTGS"],
      required: true,
      size: "12",
    },

    {
      id: "4",
      type: "inputBox",
      variant: "date",
      title: "Transaction Date",
      default: "",
      name: "date",
      size: "12",
      // min: new Date().toISOString().split("T")[0],
      required: true,
      // display: "none",
    },
    {
      id: "5",
      type: "button",
      title: "Create",
    },
  ]);
  useMemo(() => {
    if (openPopUp) {
      setForm({ ...form, customer: cus_name });
    }
  }, [openPopUp, cus_id]);
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData();
    const tempForm = form;
    tempForm["tempcustomer"] = form?.["customer"];
    tempForm["customer"] = cus_id;
    tempForm["receiver"] = user?.id;
    Object.keys(form).map((key) => data.append(key, form?.[key]));
    // data.append("user", user?.id);

    dispatch(transaction_create(data));
    setForm({});
    setOpenPopUp(false);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const convertDateFormat = (inputDate) => {
    const dateParts = inputDate.split('-');
    const formattedDate = new Date(
      Date.UTC(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]))
    );
    return formattedDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }); // DD-MM-YYYY format
  };
  return (
    <>
      <PopupForm
        open={openPopUp}
        setOpen={setOpenPopUp}
        // content={content}
        formStructure={formStructure}
        handleSubmit={handleSubmit}
        formTitle={"Create Payment"}
        key={"Form"}
        setForm={setForm}
        form={form}
        // tableData={tableData}
        // setTableData={setTableData}
        // isEdit={isEdit}
        // setIsEdit={setIsEdit}
      />
      <Card
        sx={{
          boxShadow:
            "var(--gradientColorLightest2) 0px 6px 12px -2px, var(--gradientColorLightest1) 0px 3px 7px -3px",
          borderRadius: "10px",
          p: "25px 20px 15px",
          mb: "15px",
        }}
      >
        <Box
          sx={{
            paddingBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            as="h3"
            sx={{
              fontSize: 18,
              fontWeight: 500,
            }}
          >
            Payment History
          </Typography>
          <Box
            sx={{
              paddingBottom: "10px",
              display: "flex",
              gap: "1rem",
              // justifyContent:"space-between"
            }}
          >
            <Typography
              as="h3"
              sx={{
                fontSize: 18,
                fontWeight: 500,
                mt: 1,
              }}
            >
              Total Sales :{" "}
              <span style={{ color: "orange" }}>
                ₹ {parseFloat(total_sales).toFixed(2)}
              </span>
            </Typography>
            <Typography
              as="h3"
              sx={{
                // mt:1,
                borderRight: "1px solid #b5b1b1",
              }}
            ></Typography>
            <Typography
              as="h3"
              sx={{
                fontSize: 18,
                fontWeight: 500,
                mt: 1,
              }}
            >
              Received Amount :{" "}
              <span style={{ color: "green" }}>
                ₹ {parseFloat(recevied_amount).toFixed(2)}
              </span>
            </Typography>
            <Typography
              as="h3"
              sx={{
                // mt:1,
                borderRight: "1px solid #b5b1b1",
              }}
            ></Typography>
            <Typography
              as="h3"
              sx={{
                fontSize: 18,
                fontWeight: 500,
                mt: 1,
              }}
            >
              Pending Amount :{" "}
              <span style={{ color: "red" }}>
                ₹ {parseFloat(pendding_amount).toFixed(2)}
              </span>
            </Typography>
            <Button
              type={"button"}
              variant="contained"
              style={{
                background:
                  "linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%)",
              }}
              sx={{
                // mt: 1,
                textTransform: "capitalize",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "13px",
                padding: "12px 20px",
                minWidth: "0",
                minHeight: "0",
                color: "#fff !important",
              }}
              onClick={() => setOpenPopUp(true)}
            >
             Payment
            </Button>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
          }}
        >
          <Table
            sx={{ minWidth: 600 }}
            aria-label="custom pagination table"
            className="dark-table"
          >
            <TableHead sx={{ background: "#F7FAFF" }}>
              <TableRow>
                <TableCell
                  sx={{
                    borderBottom: "1px solid var(--themeFontColor)",
                    fontSize: "13.5px",
                  }}
                >
                  Payment Date
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: "1px solid var(--themeFontColor)",
                    fontSize: "13.5px",
                  }}
                >
                  Amount
                </TableCell>

                <TableCell
                  sx={{
                    borderBottom: "1px solid var(--themeFontColor)",
                    fontSize: "13.5px",
                  }}
                >
                  Payment Mode
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? data?.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : data
              )?.map((row) => (
                <TableRow key={row?.id}>
                  <TableCell
                    sx={{
                      borderBottom: "1px solid var(--themeFontColor)",
                      fontSize: "13px",
                      pt: "16px",
                      pb: "16px",
                    }}
                  >
                    <p style={{ color: "var(--themeFontColor)" }}>{convertDateFormat(row.date)}</p>
                    {/* const convertDateFormat = (inputDate) => {
    const dateParts = inputDate.split('-');
    const formattedDate = new Date(
      Date.UTC(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]))
    );
    return formattedDate.toLocaleDateString('en-US'); // Adjust locale as needed
  }; */}
                  </TableCell>
                  
                  <TableCell
                    sx={{
                      borderBottom: "1px solid var(--themeFontColor)",
                      fontSize: "13px",
                      pt: "16px",
                      pb: "16px",
                    }}
                  >
                    <p style={{ color: "var(--themeFontColor)" }}>
                      ₹ {parseFloat(row?.amount).toFixed(2)}
                    </p>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "500",
                      fontSize: "13px",
                      borderBottom: "1px solid var(--themeFontColor)",
                      color: "#260944",
                      pt: "16px",
                      pb: "16px",
                    }}
                  >
                    <p style={{ color: "var(--themeFontColor)" }}>
                      {row?.mode_of_payment}
                    </p>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell
                    colSpan={4}
                    style={{ borderBottom: "1px solid var(--themeFontColor)" }}
                  />
                </TableRow>
              )}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={8}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={MyTask}
                  style={{ borderBottom: "none" }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
};

export default MyTasks;
